import React, { useEffect, useState } from 'react'
import { getLocalApiUrl, authFetch } from '../../../config/api'
import toast from 'react-hot-toast'
import { ArrowPathIcon } from '@heroicons/react/24/outline'

const FIELDS = [
  { key: 'data_capture_url', label: 'Data capture & create profile' },
  { key: 'smart_crop_url', label: 'SmartCrop (optional)' },
  { key: 'update_master_profile_url', label: 'Update master profile (optional)' },
  { key: 'verify_and_create_profile_url', label: 'Verify and create profile (optional)' },
  { key: 'ocr_only_url', label: 'OCR-only (used when desktop biometric is skipped)' },
]

const emptyDraft = () => ({
  data_capture_url: '',
  smart_crop_url: '',
  update_master_profile_url: '',
  verify_and_create_profile_url: '',
  ocr_only_url: '',
})

export default function TenantProfileSafeTab({ tenant }) {
  const groupId = tenant?.group_id
  const [draft, setDraft] = useState(emptyDraft())
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!groupId) return
    setLoading(true)
    authFetch(getLocalApiUrl(`/api/admin/tenants/${encodeURIComponent(groupId)}/profilesafe-urls`))
      .then((r) => r.json())
      .then((data) => {
        if (data.data) setDraft({ ...emptyDraft(), ...data.data })
      })
      .catch((e) => toast.error(e.message || 'Load failed'))
      .finally(() => setLoading(false))
  }, [groupId])

  const save = async () => {
    setSaving(true)
    try {
      const res = await authFetch(getLocalApiUrl(`/api/admin/tenants/${encodeURIComponent(groupId)}/profilesafe-urls`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(draft),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`)
      toast.success('ProfileSafe URLs saved')
    } catch (e) {
      toast.error(e.message || 'Save failed')
    } finally {
      setSaving(false)
    }
  }

  if (!tenant) return null
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500 py-8">
        <ArrowPathIcon className="h-5 w-5 animate-spin" />
        Loading…
      </div>
    )
  }

  return (
    <div className="max-w-4xl space-y-4">
      <p className="text-xs text-gray-600">
        Group-scoped ProfileSafe Azure Function URLs in <code className="text-[11px]">venue_configuration</code>.
      </p>
      {FIELDS.map(({ key, label }) => (
        <label key={key} className="block text-sm">
          <span className="font-medium text-gray-800">{label}</span>
          <input
            className="mt-1 w-full rounded-md border px-3 py-2 text-xs font-mono"
            placeholder="https://…"
            spellCheck={false}
            value={draft[key] || ''}
            onChange={(e) => setDraft((d) => ({ ...d, [key]: e.target.value }))}
          />
        </label>
      ))}
      <button
        type="button"
        onClick={save}
        disabled={saving}
        className="rounded-lg bg-psg-teal px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
      >
        {saving ? 'Saving…' : 'Save URLs'}
      </button>
    </div>
  )
}
